<template>
  <footer class="main-footer">
    <p>聊城市房地产交易市场管理所 &nbsp; &nbsp; &nbsp;客服热线:  8366009 &nbsp; &nbsp; &nbsp; 地址: &nbsp; &nbsp; &nbsp;聊城市东昌府区聚源巷2号</p>
    <p style="margin-top:30px"> <img src="@/assets/img/icon_NationalEmblem.png" alt=""> &nbsp; Copyright© {{year}}   &nbsp; &nbsp; All Right Reserid  &nbsp; &nbsp; <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">鲁ICP备17031524号-1</a></p>
  </footer>
</template>

<script>
export default {
  name: "mainFooter",
  data() {
    return {
      year: ''
    }
  },
  created() {
    let myDate = new Date();
    this.year = myDate.getFullYear();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.main-footer {
  width: 100%;
  min-width: 1140px;
  background: rgba(0, 0, 0, .8);
  padding: 40px 0 40px;
  p {
    text-align: center;
    color: #fff;
    font-size: 14px;
    vertical-align: center;
    a {
    color: #fff;
    }
  }
}
</style>
